import { render, staticRenderFns } from "./wifi.vue?vue&type=template&id=3faacabe&scoped=true"
import script from "./wifi.vue?vue&type=script&lang=js"
export * from "./wifi.vue?vue&type=script&lang=js"
import style0 from "./wifi.vue?vue&type=style&index=0&id=3faacabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faacabe",
  null
  
)

export default component.exports